import { CookiePopup } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/CookiePopup/CookiePopup';
import { PopupManager } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/PopupManager/PopupManager';
import React, { type ReactNode } from 'react';
import PremiumLogo from '../../content/assets/premium-logo-main.svg';
import { YandexMetrika } from './Head';

export interface Props {
  children: (headerProps: Record<string, any>, fallback: any) => ReactNode;
  pageContext: Record<string, any>;
  yandexMetrikaId?: string;
  isPremiumUltra: boolean;
}

const LOGO_PREMIUM = {
  image: {
    src: PremiumLogo,
  },
  title: '',
};

export const LayoutWrapper = ({
  children,
  pageContext,
  yandexMetrikaId,
  isPremiumUltra,
}: Props) => {
  const { fallback } = pageContext ?? {};

  const theme = isPremiumUltra ? 'ul' : 'pc';

  const headerProps = isPremiumUltra
    ? {
        logo: LOGO_PREMIUM,
      }
    : {};

  return (
    <>
      <YandexMetrika yandexMetrikaId={yandexMetrikaId} />
      <div data-theme={theme}>
        {children(headerProps, fallback)}
        <PopupManager />
        <CookiePopup __html={fallback?.cookieContent?.__html} />
      </div>
    </>
  );
};

export const HeaderWrapper = ({ children }: { children: ReactNode }) => (
  <div className="relative z-10 mb-lg shadow-[0_8px_32px_0px_#00000014]">{children}</div>
);

export const BodyWrapper = ({ children }: { children: ReactNode }) => (
  <div className="container space-y-px @5xl:space-y-0 @5xl:grid @5xl:grid-cols-12 @5xl:gap-2xs">
    {children}
  </div>
);
